import { createContext, useContext } from "react";

export enum CatalogueStep {
  SELECT_PRODUCTS = 1,
  SELECT_FINANCE_MODELS = 2,
  SELECT_BUNDLES = 3,
  SELECT_STOCK_PARAMETERS = 4,
  CALCULATE_STOCK = 4.5
}

export const CatalogueNavigationContext = createContext<((link: string, step?: CatalogueStep) => void) | undefined>(undefined);


export const useNavigateAndValidate = () => {
  const navigateAndValidate = useContext(CatalogueNavigationContext);

  if (!navigateAndValidate) {
    throw Error('useNavigateAndValidate must be used within a CatalogueNavigationProvider');
  }

  return navigateAndValidate;
};
